import apiClient from 'core/api/client';
import type { CreateOrganizationBody } from 'types/api.generated';

export interface Organization {
  id: string;
  name: string;
  slug: string;
  createdAt?: string;
  updatedAt?: string;
}

export const createOrganization = async (
  body: CreateOrganizationBody,
): Promise<Organization> => {
  const { data } = await apiClient.post<Organization>('/api/v1/organizations', body);
  return data;
};
